import { Injectable } from '@angular/core';
import { differenceInHours, differenceInMinutes } from 'date-fns';

import { WindowService } from '../../../core/window-actions/window.service';

@Injectable()
export class FlightTrackerResultsService {
  currentTime = new Date();
  isMobile: boolean;

  constructor(private windowService: WindowService) {
    this.isMobile = false;
    this.windowService.windowSizeChanged.subscribe(size => {
      this.isMobile = !!size.small;
    });
  }

  setStatusColor(status: string): string {
    if (status.includes('DELAY')) {
      return 'orange';
    } else if (status.includes('CLOS')) {
      return 'red';
    } else if (status.includes('BOARDING')) {
      return 'mint-green';
    } else if (status.includes('CANCELLED')) {
      return 'yellow';
    } else {
      return 'core-blue';
    }
  }

  calculateRemainingTime(arrivalTime: string): string {
    const arrivalDate = arrivalTime ? new Date(arrivalTime) : undefined;
    let hoursLeft = differenceInHours(arrivalDate, this.currentTime);
    let minLeft = differenceInMinutes(arrivalDate, this.currentTime);
    if (hoursLeft <= 0 && minLeft <= 0) {
      hoursLeft = 0;
      minLeft = 0;
    }
    return `${hoursLeft} hour(s), ${minLeft % 60} mins`;
  }

  convertTime(time: string): string {
    if (time) {
      return time.slice(0, 19);
    }
  }
}
